import React from 'react';
import classNames from "classnames";

const Popup = (props) => {

    const {title, body, onClose, open, children} = props

    return (
        <div className={classNames({
            'app_popup': true,
            "open": open
        })}>
            <div className="app_popup_overlay">
                <div className="app_popup_wrapper">
                    <svg className={'close_icon'} onClick={onClose} xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                        <path d="M7.07033 21.2124L21.2125 7.07031" stroke="#000034" strokeWidth="2"/>
                        <path d="M21.214 21.2124L7.07184 7.07031" stroke="#000034" strokeWidth="2"/>
                    </svg>
                    {title ? <h1>{title}</h1> : null}
                    {body ? <p>{body}</p> : null}
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Popup;